import { Button, Col, Input, Row, Select } from 'antd';
import React, { ReactElement, useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import { useHistory, useLocation } from 'react-router-dom';
import PageHeader from '../../../../shared/components/pageHeader/PageHeader';
import { authFeatureConstants, FETCH_PACKAGE, GUTTOR_SPACE_SMALL, INVENTROY_CONSTANTS, PACKAGE_TYPE, StatusFilterType } from '../../../../shared/constants/commonConstants';
import { DEPARTMENT_HC, FETCH_INVENTORY_DASHBOARD } from '../../../../shared/constants/urlEndPoints';
import { FetchPackageRequest, FetchPackageResponse } from '../../../../shared/models/packageDetail.model';
import ApplicationDetail from '../../../../shared/services/applicationDetail.service';
import SendRequest from '../../../../shared/services/sendRequest.service';
import { dashBoardRequest } from '../../../../store/actions/leftSideBarAction';
import { base64UrlEncode, canActivate, error, extractSecondLevelBaseUrl } from '../../../../utils/utility';
import LabTestList from './LabTestList';

const LabTests = ({ match }: any): ReactElement => {
  const pageNumber: any = new URLSearchParams(useLocation().search).get('page');
  const { Option } = Select;
  const [packageItem, setPackageDetailHandler] = useState(null as any);
  const [labTestDepartments, setlabTestDepartmentsHandler] = useState(null as any);
  const [department, setdepartmentHandler] = useState([] as any);
  const [packageInput, setpackageInputHandler] = useState(null as any);
  const [totalPages, setTotalPagesHandler] = useState(0 as number);
  const [currentPage, setcurrentPageHandler] = useState(pageNumber ? pageNumber : 1);
  const [statusType, setStatusType] = useState('Select status');
  const profileId = [ApplicationDetail.instance.getProfileId()];
  const history = useHistory();
  const dispatch = useDispatch();
  const dashboardPayload: any = {
    title: INVENTROY_CONSTANTS.labTests,
    url: `${process.env.REACT_APP_INVENTORY_API_BASE_URL}${FETCH_INVENTORY_DASHBOARD}`, type: PACKAGE_TYPE.LABTEST,
  };
  useEffect((): void => {
    fetchLabTestDepartments();
    filterLabTestPackages([], '', currentPage, '', 5, true);
    if (pageNumber) {
      removeQueryParam();
    }
  }, []);

  const removeQueryParam = (): void => {
    window.history.pushState('', '', window.location.pathname);
  };

  const filterLabTestPackages = async (
    deptIds: number[],
    packageName: string,
    pageNo?: number,
    status?: string,
    pageSize?: number, isFlag?: boolean): Promise<any> => {

    const payload: FetchPackageRequest = {
      packageByProfileId: true,
      packageType: PACKAGE_TYPE.LABTEST,
      fetchInActiveRecord: true,
      profileIds: profileId,
      statusType: status === '' || status === 'Select status' ? StatusFilterType.isDefault : status,
      pageNumber: pageNo,
      pageSize: pageSize ? pageSize : 5,
      departmentIds: deptIds,
      name: packageName,
      packageByName: packageName !== null && packageName !== '' && packageName !== undefined,
      packageByDepartmentId: deptIds !== null && deptIds.length > 0,
    };
    dashboardPayload.filter = {
      departmentIds: payload?.departmentIds,
      name: payload?.name,
      statusName: payload?.statusType,
    };
    if (!isFlag) {
      dispatch(dashBoardRequest(dashboardPayload));
    }
    const url = process.env.REACT_APP_INVENTORY_API_BASE_URL + FETCH_PACKAGE;
    const result: any = await SendRequest.instance.post<
      FetchPackageRequest,
      FetchPackageResponse
    >(url, payload);
    if (result && result.isSuccess) {
      const validPackages = result.packages?.filter((item: any): any => item.investigations !== undefined);
      setPackageDetailHandler(validPackages);
      setTotalPagesHandler(result.totalRecords);
    } else {
      error('Tests not configured.Please to configure tests.');
      setPackageDetailHandler([]);
      setTotalPagesHandler(0);
    }
  };

  const fetchLabTestDepartments = async (): Promise<any> => {
    const departmentResponse = await SendRequest.instance.get<any>(process.env.REACT_APP_INVENTORY_API_BASE_URL + DEPARTMENT_HC);
    if (departmentResponse && departmentResponse.isSuccess && departmentResponse.lookUpData) {
      setlabTestDepartmentsHandler(departmentResponse.lookUpData);
    } else if (departmentResponse && departmentResponse.errorMessage) {
      error(departmentResponse.errorMessage);
    } else {
      error('Unable to fetch departments. Please try after some time.');
    }
  };

  const onDepartmentSelection = async (v: string[]): Promise<any> => {
    setdepartmentHandler(v);
    setcurrentPageHandler(1);
    const depIds = labTestDepartments.filter((vv: any): boolean => {
      return v.findIndex((c: string): boolean => c === vv.value) > -1;
    }).map((vvv: any): any => vvv.id);
    filterLabTestPackages(depIds, packageInput, 1, statusType);
  };

  const onLabTestNameSearch = (e: any): any => {
    const depIds = labTestDepartments.filter((vv: any): boolean => {
      return department.findIndex((c: string): boolean => c === vv.value) > -1;
    }).map((vvv: any): any => vvv.id);

    const input: string = e.target.value || '';
    if (input !== '') {
      if (input && input.length >= 3) {
        setpackageInputHandler(e.target.value);
        setcurrentPageHandler(1);
        filterLabTestPackages(depIds, e.target.value, 1, statusType);
      }
    } else {
      setpackageInputHandler(undefined);
      const deptIds = labTestDepartments.filter((vv: any): boolean => {
        return department.findIndex((c: string): boolean => c === vv.value) > -1;
      }).map((vvv: any): any => vvv.id);
      filterLabTestPackages(deptIds, '', currentPage, statusType);
    }
  };

  const onClearDropDown = (): void => {
    filterLabTestPackages([], packageInput, currentPage);
  };

  const fetchPaginationData = (pageNo: any, pageSize?: any): any => {
    setcurrentPageHandler(pageNo);
    const depIds = labTestDepartments.filter((vv: any): boolean => {
      return department.findIndex((c: string): boolean => c === vv.value) > -1;
    }).map((vvv: any): any => vvv.id);

    filterLabTestPackages(depIds, packageInput, pageNo, statusType, pageSize);
  };
  const redirect = (): void => {
    history.push(extractSecondLevelBaseUrl(match.path) + '/edit-labtest-packages/' + base64UrlEncode('0') + '/' + base64UrlEncode('0'));
  };

  const onStatusFilter = (status: string): void => {
    setStatusType(status ? status : 'Select status');
    setcurrentPageHandler(1);
    const depIds = labTestDepartments.filter((vv: any): boolean => {
      return department.findIndex((c: string): boolean => c === vv.value) > -1;
    }).map((vvv: any): any => vvv.id);
    filterLabTestPackages(depIds, packageInput, 1, status);
  };

  return (
    <div>
      <PageHeader
        pageTitle="Lab Test"
        customeClass={'inv-page-header-align'}
        colSize={4}
        rightComponent={
          (): ReactElement =>
            <Row gutter={GUTTOR_SPACE_SMALL}>
              <Col md={7}>
                <Select
                  style={{ width: '100%' }}
                  value={statusType}
                  allowClear={statusType !== 'Select status' ? true : false}
                  onClear={(): void => setStatusType('Select status')}
                  onChange={(e: any): any => onStatusFilter(e)}
                >
                  <Option value={StatusFilterType.isApproved}>Verified</Option>
                  <Option value={StatusFilterType.isSubmit}>Pending</Option>
                  <Option value={StatusFilterType.isRejected}>Rejected</Option>
                </Select>
              </Col>
              <Col md={7}>
                <Select
                  className="w-100 scrollable-select mouse-pointer"
                  mode={'multiple'}
                  placeholder="Department"
                  optionLabelProp="label"
                  onChange={onDepartmentSelection}
                  options={labTestDepartments}
                  value={department}
                  allowClear={department ? true : false}
                  onClear={onClearDropDown}
                />
              </Col>
              <Col md={7} >
                <Input
                  ref={(input: any): any => input && input.focus()}
                  className="w-100"
                  defaultValue={packageInput}
                  allowClear={packageInput ? true : false}
                  placeholder={'Search'}
                  onChange={onLabTestNameSearch}
                />
              </Col>
              {
                canActivate(authFeatureConstants.EDIT_LAB_TESTS) &&
                <Col md={3} style={{
                  display: 'flex',
                  justifyContent: ' flex-end',
                }}>
                  <Button onClick={(): void => redirect()} type={'primary'} htmlType={'submit'}>+ Add Test</Button>
                </Col>
              }
            </Row>
        }
      />
      <div className="ant-tabs-content-holder tab-custom-container">
        <LabTestList paginationChangeEvent={fetchPaginationData} packageItems={packageItem} match={match} totalRecords={totalPages}
          currentPage={currentPage} />
      </div>
    </div>
  );
};

export default LabTests;
